import {
  ActiveFiltersSuccess,
  AddActiveMobileFilters,
  AddOtherPageCountLoadPharmaciesAction,
  AddPageCountLoadPharmaciesAction,
  AddQuantityAction,
  ChangePharmaciesCityAction,
  ClearFoundActionSuccess,
  ClearListPharmaciesAction,
  isGetOtherCityPharmaciesAction,
  IsTargetFromProductCardGetOtherCityPharmaciesAction,
  PharmaciesPageState,
  PopupOnePharmcyForActivaMarkerAction,
  PrivatePageChangeCurrentBlock,
  PrivatePageExceptionReturnBtn,
  ResetFiltersFromMobilePharmaciesPopup,
  ResetOtherPageCountLoadPharmaciesAction,
  ResetPageCountLoadDataAction,
  ResetPageCountLoadPharmaciesAction,
  SetAddressAction,
  SetCenterMapAction,
  SetCurrentCityAction,
  SetCurrentFiltersAction,
  SetFiltersFromMobilePharmaciesPopup,
  SetIsGeoLocationDisabled,
  SetZoomMapAction,
  SwitchMobilePageMapAction
} from '../../store/actions';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { ActivatedRoute, Data, Params, Router } from '@angular/router';
import { AppState } from '@appStates';
import { LocalizationService, ScreenDetectedService, SeoService } from '@core/services';
import { ECurrentOrderBlock, ListLazyComponents, Pages } from '@enums';
import {
  BzApteka,
  Crumb,
  FilterListPharmcies,
  IBanner,
  ICity,
  IDesktopFilter,
  IPharmacieFilters,
  IPharmacyFaq,
  IPharmacyTable,
  IProduct,
  RequestParamsListPharmcy
} from '@interfaces';
import { select, Store } from '@ngrx/store';
import { QuantityForOneProduct } from '@states';
import { combineLatest, Observable, Subject } from 'rxjs';
import { take, takeUntil, delay, } from 'rxjs/operators';
import { LazyLoadComponentsService } from 'src/app/lazy-load-components-ui/factories/lazy-load-components.service';
import { PharmcyPageService } from 'src/app/core/services/helpers/pharmcy-page.service';
import {
  selectActiveMobilesFiltersLength,
  selectCountForOneProduct,
  selectIsGetOtherPharmacies,
  selectIsLoadingListPharmacies,
  selectIsTargetFromProductCardGetOtherCityPharmacies,
  selectListPharmacies,
  selectOnePharmaForPopupActiveMarker,
  selectPharmBanner,
  selectSeoFaqs,
  selectSeoPreparatText,
  selectSeoPriceTabe,
  selectSwitchMobilePageMap,
  selectTotalPharmaciesLength,
  selectTotalPharmaciesOtherLength
} from 'src/app/store/selectors/pharmacy.selectors';
import { selectAddress } from '../../store/selectors';
import { ApplicationRoutingService } from '@application-routing';
import { isPlatformBrowser, isPlatformServer, KeyValue, PlatformLocation } from '@angular/common';
import { SearchPharmaciesApiService } from '../../core/services/api.services/search-pharmacies-api.service';
import { LocationStorageService } from '../../core/services/storage.services/location-storage-service.service';
import { PharmaciesNavigationHelperService } from 'src/app/core/services/helpers/help-service-for-search-page/pharmacies-navigation-helper.service';
import { JsonLDServiceService } from 'src/app/core/services/seo.services/json-ldservice.service';
import { GeoLocationService } from 'src/app/core/services/positioning.services/geo-location.service';
import { Actions, ofType } from '@ngrx/effects';
import { CookiesServiceService } from 'src/app/core/services/storage.services/cookies-service.service';
import { PharmaciesPageSeoHelperService } from 'src/app/core/services/helpers/seo-title-description-pharmacies-page.service';
import { environment } from '@env';
import { IFullAddress } from 'src/app/shared/interfaces/location/full-adress-response.model';
import { RestUrlService, TypeUrl } from 'src/app/core/services/api.services/settings/rest-url.service';

export enum ActiveMobileBlock {
  list = 'list.block.pharm',
  map = 'map.block.pharm'
}

@Component({
  selector: 'app-pharmacies',
  templateUrl: './pharmacies.component.html',
  styleUrls: ['./pharmacies.component.sass']
})
export class PharmaciesComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('containerMap') public containerMap: ElementRef;
  @ViewChild('map', { read: ViewContainerRef }) public map: ViewContainerRef;
  @ViewChild('mobileFilters', { read: ViewContainerRef }) public mobileFilters: ViewContainerRef;

  public filterList: Map<string, FilterListPharmcies>;
  public filtersKeys: Set<string> = new Set<string>().add('fif').add('enf').add('ds').add('ps').add('qs');
  public iconObj = {
    'background-color': '#292929bf',
    mask: 'url(../../../../../assets/down-arrow-apteka-block.svg) no-repeat center',
    '-webkit-mask': 'url(../../../../../assets/down-arrow-apteka-block.svg) no-repeat center',
    '-webkit-mask-size': 'contain',
    'mask-size': 'contain'
  };
  public iconFtObj = {
    'background-color': '#292929bf',
    mask: 'url(../../../../../assets/filter.svg) no-repeat center',
    '-webkit-mask': 'url(../../../../../assets/filter.svg) no-repeat center',
    '-webkit-mask-size': 'contain',
    'mask-size': 'contain'
  };
  public selectedUserCityName: string;
  public _search_pharmcy_params: RequestParamsListPharmcy[];
  public _search_pharmcy_params_name: string;
  public _search_pharmcy_params_count: number;
  public isListSearch: boolean;
  public closed: boolean = false;
  public primaryHeightMapContent: string;
  public pharmaciesList: Observable<Map<number, BzApteka>> = this.store.pipe(select(selectListPharmacies('primary')));
  public pharmaciesOtherList: Observable<Map<number, BzApteka>> = this.store.pipe(select(selectListPharmacies('other')));
  public pharmaciesListInCart: Observable<Map<number, BzApteka>> = this.store.pipe(select(selectListPharmacies('top')));
  public seoPreparatText: Observable<string> = this.store.pipe(select(selectSeoPreparatText));
  public totalPharmaciesLength: Observable<boolean> = this.store.pipe(select(selectTotalPharmaciesLength));
  public totalPharmaciesOtherLength: Observable<boolean> = this.store.pipe(select(selectTotalPharmaciesOtherLength));
  public countForOneProduct: Observable<QuantityForOneProduct> = this.store.pipe(select(selectCountForOneProduct));
  public countOfActiveMobileFilters: Observable<number>;
  public isLoadingListPharmacies: Observable<boolean> = this.store.pipe(select(selectIsLoadingListPharmacies));
  public selectedPharmacyForPopup: BzApteka | null = null;
  public isActiveMapPage: Observable<boolean> = this.store.pipe(select(selectSwitchMobilePageMap));
  public selectedAddress: Observable<IFullAddress> = this.store.pipe(select(selectAddress));
  public seoFaqsData: Observable<IPharmacyFaq | null> = this.store.pipe(select(selectSeoFaqs));
  public seoTableData: Observable<IPharmacyTable | null> = this.store.pipe(select(selectSeoPriceTabe));
  public banner$: Observable<IBanner | null> = this.store.pipe(select(selectPharmBanner));
  public currentLang: string;
  public cityForH1: string;
  public currentFilterForBlock: ActiveMobileBlock = ActiveMobileBlock.list;
  public crumbs: Crumb[] = [];
  public bannerImages: string;

  private isDistanceFilterRemoved: boolean = false;
  private listenerFn: () => void;
  private isFirstLoad: boolean = true;
  private needToResetMap: boolean = false;
  private shouldAutoSetDistanceFilter: boolean = false;
  private componentDestroyer: Subject<void> = new Subject();

  @HostListener('window:popstate', ['$event']) onPopState(): void {
    if (this.scr.isMobile()) {
      setTimeout(() => {
        if (!window.location.search.includes('map=true')) {
          this.currentFilterForBlock = ActiveMobileBlock.list;
          this.store.dispatch(SwitchMobilePageMapAction({ active: false }));
          this.setHeightForMap('auto');
        }
        this.checkActiveFilters();
      }, 0);

      const filtersPopup = document.getElementById('popupGlobalApp').firstChild;
      if (filtersPopup) {
        this.lazy.clearContainerPopupGlobalContainer(filtersPopup);
      }
    }
  }

  trackById = (_: unknown, item: BzApteka) => item.id;

  constructor(
    public readonly scr: ScreenDetectedService,
    @Inject(PLATFORM_ID) private readonly platformId: Object,
    private readonly location: LocationStorageService,
    private readonly searchPharmaciesApiService: SearchPharmaciesApiService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly route: ActivatedRoute,
    private readonly store: Store<AppState>,
    private readonly geo: GeoLocationService,
    private readonly jsonLDService: JsonLDServiceService,
    private readonly router: Router,
    private readonly appRoutingService: ApplicationRoutingService,
    private readonly local: LocalizationService,
    private readonly seoService: SeoService,
    private readonly lazy: LazyLoadComponentsService,
    private readonly navigationHelper: PharmaciesNavigationHelperService,
    private readonly platformLocation: PlatformLocation,
    private readonly actions: Actions,
    private readonly cook: CookiesServiceService,
    private readonly pharmaciesSeoHelper: PharmaciesPageSeoHelperService,
    private readonly url: RestUrlService
  ) {
    this.bannerImages = this.url.getUrl(TypeUrl.img) + '/ad/';
    this.route.data.pipe(
      takeUntil(this.componentDestroyer)
    ).subscribe((data: Data) => {
      this.seoService.getTegRobots(Pages.pharmacies);
      this.seoService.updateLinkHreflang();
      const guardData: {
        city: ICity,
        product: IProduct,
        permissionStatus: PermissionStatus | null,
        isGeolocationDisabled: boolean,
        isList: boolean
      } | undefined = data[0];
      if (guardData) {
        this.checkGeoLocationStateFromGuardData(guardData);
        if (!guardData.isList) {
          this.checkGuardDataAndSetSeoStuff(guardData);
          if (guardData.city && this.isFirstLoad) {
            const selectedAddress: IFullAddress | null = this.location.address ? JSON.parse(this.location.address) : null;
            const selectedCityName: string = this.location.cityName;
            this.setCurrentCityForH1(guardData.city);
            this.setInitialCenterMap(guardData, selectedAddress, selectedCityName);
            this.geo.hidePopUp.next(true);
            this.needToResetMap = true;
          } else {
            this.setCurrentCityForH1(guardData.city);
            this.geo.hidePopUp.next(false);
            this.needToResetMap = false;
          }
          this.buildAndSetTitleAndDescription(guardData.product.name, guardData.product.description);
          this._search_pharmcy_params_name = guardData.product.name;
          this.setSeoProductScript(guardData.product);
        }
      }
      if (guardData.isList) {
        /* TODO: Create title and description while searching with list */
        this.seoService.setStaticTitle('start.page.meta.teg.title');
        this.seoService.setStaticDescription('start.page.meta.teg.description');
      }
      this.isFirstLoad = false;
    });

    this.filterList = new Map()
      .set('ds', { name: 'ds', active: false }) // по расстоянию
      .set('ps', { name: 'ps', active: false }) // по цене
      .set('qs', { name: 'qs', active: false }) // по количеству в списке
      .set('fif', { name: 'fif', active: false }) // полный список
      .set('enf', { name: 'enf', active: false }); // точное количество
    this.getCurrentParams();
    this.setInitCityName();
  }

  ngOnInit(): void {
    this.currentLang = this.local.getLang();
    this.checkAddressState();
    this.detectedHightContentBlock();
    this.cityChangeListener();
    this.setMobileFiltersPopupListener();
    this.resetFiltersFromMobilePopup();

    this.store.pipe(
      select(selectOnePharmaForPopupActiveMarker),
      takeUntil(this.componentDestroyer)
    ).subscribe((apteka: BzApteka | null) => {
      this.selectedPharmacyForPopup = apteka;
      this.changeDetectorRef.detectChanges();
    });

    if (this.scr.isMobile()) {
      this.countOfActiveMobileFilters = this.store.pipe(select(selectActiveMobilesFiltersLength));
    }
    this.setCurrentFilters();
  }

  public getPharmies(
    params: RequestParamsListPharmcy[],
    additionalLoading: boolean = false,
    filterParams?: Map<string, FilterListPharmcies>
  ): void {
    if (filterParams) { filterParams = new Map([...filterParams.entries()].filter(item => item[1].active)); }
    this.store.pipe(select(selectIsGetOtherPharmacies), take(1)).subscribe((other: boolean) => {
      if (!additionalLoading) {
        this.store.dispatch(ClearListPharmaciesAction());
        this.store.dispatch(ResetPageCountLoadPharmaciesAction());
      }
      if (!this.isDistanceFilterRemoved && this.shouldAutoSetDistanceFilter && !filterParams.get('ps')) {
        filterParams.set('ds', { name: 'ds', active: true });
        this.filterList.get('ds').active = true;
      }
      this.setCurrentFilters();
      this.searchPharmaciesApiService.getListPharmcies(params, filterParams, other);
    });
  }

  public openMobileFiltersModal(): void {
    this.lazy.addToGlobalPopup(
      ListLazyComponents.mobilePharmaciesFilters,
      {
        filters: this.filterList,
        isListSearch: this.isListSearch,
        currentFilterForBlock: this.currentFilterForBlock,
      }
    );
    document.body.style.overflow = 'hidden';
  }

  public backState(): void {
    if (this.currentFilterForBlock === ActiveMobileBlock.list) {
      history.back();
    }
  }

  public toggleMobilePageState(): void {
    if (this.currentFilterForBlock === ActiveMobileBlock.map) {
      setTimeout(() => {
        if (!window.location.search.includes('map=true')) {
          this.currentFilterForBlock = ActiveMobileBlock.list;
          this.store.dispatch(SwitchMobilePageMapAction({ active: false }));
          this.setHeightForMap('auto');
        }
      }, 0);
      this.closedRightPopup();
    }
  }

  public switchBlockVisible(): void {
    this.toggleMapParams();
    this.currentFilterForBlock = ActiveMobileBlock.map;
    this.store.dispatch(SwitchMobilePageMapAction({ active: true }));
    this.setHeightForMap('100vh');
    setTimeout(_ => {
      this.loadMap();
    }, 0);
  }

  public toChangeRegion(): void {
    if (this.scr.isMobile()) {
      this.toggleMapParams();
    }
    setTimeout(() => {
      this.store.dispatch(PrivatePageChangeCurrentBlock({ currentBlock: ECurrentOrderBlock.location }));
      this.store.dispatch(PrivatePageExceptionReturnBtn({ exception: this.router.routerState.snapshot.url }));
      this.appRoutingService.navigate(ListLazyComponents.private, this.router.routerState.snapshot.url);
      this.store.dispatch(PharmaciesPageState({ currentState: this.currentFilterForBlock }));
    }, 0);
  }

  public toChangeDesktopLocation(): void {
    this.appRoutingService.navigate(ListLazyComponents.location, this.router.routerState.snapshot.url);
  }

  public ngAfterViewInit(): void {
    if (this.scr.isDesktop()) { this.loadMap(); }
  }

  public loadMap(): void {
    this.lazy.addCoreLazyComponent(this.map, ListLazyComponents.map);
  }

  public clickItemMenu(event: IDesktopFilter): void {
    if (event.value.name === 'ds' && event.value.active) {
      this.isDistanceFilterRemoved = true;
      const params: Params = this.route.snapshot.queryParams;
      if (!params['ds']) {
        const newfilterMap = new Map(this.filterList).set('ds', { name: 'ds', active: false });
        this.getPharmies(this._search_pharmcy_params, false, newfilterMap);
      }
    }
    this.store.dispatch(ResetOtherPageCountLoadPharmaciesAction());

    this.store.pipe(
      select(selectIsTargetFromProductCardGetOtherCityPharmacies),
      take(1)
    ).subscribe((other: boolean) => {
      this.store.dispatch(isGetOtherCityPharmaciesAction({ other }));
    });

    this.filterList.set(event.key, {
      ...event.value,
      active: !event.value.active
    });

    if (event.key === 'ps' && this.filterList.get('ds').active) {
      this.filterList.get('ds').active = false;
      this.isDistanceFilterRemoved = true;
    }

    if (event.key === 'ds' && this.filterList.get('ps').active) {
      this.filterList.get('ps').active = false;
    }

    if (event.key === 'enf' && !event.value.active) {
      this.filterList.set('fif', {
        ...this.filterList.get('fif'),
        active: true
      });
    } else if (event.key === 'enf' && event.value.active && this.isListSearch) {
      this.filterList.set('fif', {
        ...this.filterList.get('fif'),
        active: false
      });
      this.filterList.set('enf', {
        ...this.filterList.get('enf'),
        active: false
      });
    } else if (event.key === 'fif' && event.value.active) {
      this.filterList.set('enf', {
        ...this.filterList.get('enf'),
        active: false
      });
    }

    let filterParams: Params;
    this.route.queryParams.pipe(take(1)).subscribe((params: Params) => filterParams = params);

    [...this.filterList.values()]
      .filter(item => item.active || item.active === 'true')
      .forEach(item => filterParams = { ...filterParams, [item.name]: item.active });

    filterParams = {
      ...filterParams,
      fif: filterParams.fif !== 'true' && filterParams.fif !== 'false' && filterParams.fif,
      enf: filterParams.enf !== 'true' && filterParams.enf !== 'false' && filterParams.enf,
      ds: filterParams.ds !== 'true' && filterParams.ds !== 'false' && filterParams.ds,
      ps: filterParams.ps !== 'true' && filterParams.ps !== 'false' && filterParams.ps,
      qs: filterParams.qs !== 'true' && filterParams.qs !== 'false' && filterParams.qs,
    };

    let result: Params;
    for (const key in filterParams) {
      if (filterParams[key]) { result = { ...result, [key]: filterParams[key] }; }
    }

    if (this.scr.isMobile()) { this.setCurrentFilters(); }

    this.route.params.pipe(take(1)).subscribe((params: Params) => {
      if (!this.isListSearch && params.url) {
        this.router.navigate(this.local.getReturnParamsLang(
          ['pharmacies', params.url, this.compareCitiesAndReturnRequired()]
        ), { queryParams: result });
      } else {
        this.router.navigate(this.local.getReturnParamsLang(['pharmacies']), { queryParams: result });
      }
    });
  }

  public setCurrentFilters(): void {
    if (this.scr.isMobile()) {
      const filters: FilterListPharmcies[] = Array.from(this.filterList.values());
      const activeFilters: FilterListPharmcies[] = filters.filter(object => object.active === true);
      const result: string[] = [];
      activeFilters.forEach((filter: FilterListPharmcies) => result.push(filter.name));
      this.store.dispatch(AddActiveMobileFilters({ keys: result }));
    }
  }

  public addChildQuantity(event: number): void {
    this.countForOneProduct.pipe(take(1)).subscribe((data: QuantityForOneProduct) => {
      let current: QuantityForOneProduct = { ...data };
      const result: number = current.blisterNum + 1;
      if (result === current.packageContentNum) {
        current = { ...current, packageNum: current.packageNum + 1, blisterNum: 0 };
        this.addParamsQuantity(current.packageNum, current.blisterNum);
        return;
      }
      this.addParamsQuantity(current.packageNum, result);
    });
  }

  public removeChildQuantity(event: number): void {
    if (event > 0) {
      this.countForOneProduct.pipe(take(1)).subscribe((data: QuantityForOneProduct) => {
        let current: QuantityForOneProduct = { ...data };
        const result: number = current.blisterNum - 1;
        if (result >= 0) {
          current = { ...current, blisterNum: result };
          if (current.blisterNum === 0 && current.packageNum === 0) { return; }
          this.addParamsQuantity(current.packageNum, current.blisterNum);
          return;
        }
      });
    } else {
      this.countForOneProduct.pipe(take(1)).subscribe((data: QuantityForOneProduct) => {
        let current: QuantityForOneProduct = { ...data };
        current = { ...current, packageNum: current.packageNum - 1, blisterNum: current.packageContentNum - 1 };
        this.addParamsQuantity(current.packageNum, current.blisterNum);
      });
    }
  }

  public addParentQuantity(event?: number): void {
    this.countForOneProduct.pipe(take(1)).subscribe((data: QuantityForOneProduct) => {
      let current: QuantityForOneProduct = { ...data };
      const res = +((Number(current.packageNum) + 1));
      this.addParamsQuantity(res, current.blisterNum);
    });
  }

  public removeParentQuantity(event?: number): void {
    this.countForOneProduct.pipe(take(1)).subscribe((data: QuantityForOneProduct) => {
      let current: QuantityForOneProduct = { ...data };
      const result: number = +((current.packageNum - 1));

      if (result > 0) {
        this.addParamsQuantity(result, current.blisterNum);
      }

      if (result === 0) {
        if (current.packageContentNum === 1) {
          this.addParamsQuantity(1, 0);
        } else if (current.packageContentNum === 0 && current.blisterNum === 0) {
          this.addParamsQuantity(1, 0);
        } else {
          this.addParamsQuantity(0, 1);
        }
      }
    });
  }

  public getNextPharmacies(other: boolean = false): void {
    if (other) {
      this.store.dispatch(AddOtherPageCountLoadPharmaciesAction());
    } else {
      this.store.dispatch(AddPageCountLoadPharmaciesAction());
    }
    this.store.dispatch(isGetOtherCityPharmaciesAction({ other }));
    this.getPharmies(this._search_pharmcy_params, true, this.filterList);
  }

  public clearSearchState(): void {
    this.store.dispatch(SetCurrentFiltersAction({ current: [] }));
    this.store.dispatch(ActiveFiltersSuccess({ count: 0 }));
    this.store.dispatch(ClearFoundActionSuccess());
    this.store.dispatch(ResetPageCountLoadDataAction());
  }

  public getCrumbRouterLink(crumb: Crumb): string {
    if (crumb.info === 'full') {
      return this.local.getRouterLinkApp('info-drug') + '/' + crumb.url + '/' + crumb.productId;
    }
    if (crumb.info === '3') {
      return this.local.getRouterLinkApp('category') + '/' + crumb.url;
    }
    if (crumb.info === 'preparat') {
      return this.local.getRouterLinkApp('preparat') + '/' + crumb.url;
    }
    return this.local.getRouterLinkApp('catalog') + '/' + crumb.url;
  }

  public closedRightPopup(): void {
    this.closed = true;
    setTimeout(() => {
      this.store.dispatch(PopupOnePharmcyForActivaMarkerAction({ pharmcy: null }));
      this.closed = false;
    }, 450);
  }

  public clickOutsideMap(event: MouseEvent): void {
    if (this.scr.isMobile()) {
      return;
    }
    if (
      this.selectedPharmacyForPopup &&
      (event?.target as Element)?.className !== 'pharmy-pin' &&
      (event?.target as Element)?.parentElement?.className !== 'pharmy-pin'
    ) {
      this.closedRightPopup();
    }
  }

  public getHomeLink(): string {
    return this.local.getRouterLinkApp('/');
  }

  public originalOrder = (
    a: KeyValue<number, string>,
    b: KeyValue<number, string>
  ): number => {
    return 0;
  }

  public bzOutsideFromMobileVersion(event: MouseEvent): void {
    if (
      this.scr.isMobile() &&
      !(event?.target as Element)?.className.includes('map-container') &&
      !(event?.target as Element)?.parentElement.className.includes('map-container') &&
      (event?.target as Element)?.className !== 'pharmy-pin' &&
      (event?.target as Element)?.parentElement?.className !== 'pharmy-pin'
    ) {
      this.closedRightPopup();
    }
  }

  private detectedHightContentBlock(): void {
    if (this.scr.isDesktop()) {
      if (this._search_pharmcy_params_count) {
        this.primaryHeightMapContent = (window.innerHeight - 125) + 'px';
      } else {
        this.primaryHeightMapContent = (window.innerHeight - 165) + 'px';
      }
    } else {
      this.primaryHeightMapContent = (window.innerHeight - 160) + 'px';
    }
  }

  private compareCitiesAndReturnRequired(): string {
    const currentTown: string = this.location.townEn;
    const townFromUrl: string = this.searchPharmaciesApiService.getTownFromUrl();
    const result: string = townFromUrl !== currentTown ? townFromUrl : currentTown;
    return result;
  }

  private buildAndSetTitleAndDescription(productName: string, productDescription: string): void {
    const { title, description } = this.pharmaciesSeoHelper.buildTitleAndDescription(productName, productDescription, this.cityForH1);
    this.seoService.setStaticTitleWithOutTranslate(title);
    this.seoService.setStaticDescriptionWithOutTranslate(description);
  }

  private setSeoProductScript(product: IProduct): void {
    this.jsonLDService.add(
      JsonLDServiceService.Product(product, this.platformLocation.href ?? ''),
      'structured-data-product'
    );
  }

  private addParamsQuantity(packs: number, blisters: number, clearParams?: boolean): void {
    const additionalParams: IPharmacieFilters = {};

    let urlForSingleProduct: string;
    this.route.params.pipe(take(1)).subscribe(params => urlForSingleProduct = params.url);

    this.route.queryParams.pipe(take(1)).subscribe((data: Params) => {
      if (data.fif) { additionalParams.fif = data.fif; }
      if (data.enf) { additionalParams.enf = data.enf; }
      if (data.ds) { additionalParams.ds = data.ds; }
      if (data.ps) { additionalParams.ps = data.ps; }
      if (data.qs) { additionalParams.qs = data.qs; }
    });

    let qtyForOneProduct: QuantityForOneProduct;
    this.countForOneProduct.pipe(take(1)).subscribe(state => qtyForOneProduct = state);

    this.router.navigate(this.local.getReturnParamsLang(
      ['pharmacies', urlForSingleProduct, this.compareCitiesAndReturnRequired()]
    ), qtyForOneProduct.packageContentNum !== 1 ? {
      queryParams: {
        id: this._search_pharmcy_params[0].id,
        p: packs,
        b: blisters,
        ...additionalParams
      }
    } : {
      queryParams: {
        id: this._search_pharmcy_params[0].id,
        p: packs,
        ...additionalParams
      }
    });
  }

  private toggleMapParams(): void {
    this.route.params.pipe(take(1)).subscribe((params: Params) => {
      if (!this.isListSearch && params.url) {
        this.router.navigate(this.local.getReturnParamsLang(['pharmacies', params.url, this.compareCitiesAndReturnRequired()]), {
          queryParamsHandling: 'merge'
        });
      } else {
        this.router.navigate(this.local.getReturnParamsLang(['pharmacies']), {
          queryParamsHandling: 'merge'
        });
      }
    });
  }

  private setHeightForMap(size: string): void {
    if (isPlatformBrowser(this.platformId)) {
      const contentWrapper = document.getElementsByClassName('main-content')[0];
      (contentWrapper as HTMLElement).style.height = size;
      this.changeDetectorRef.detectChanges();
    }
  }

  private checkActiveFilters(): void {
    setTimeout(() => {
      const params: Params = this.router.routerState.snapshot.root.queryParams;
      for (const key in params) {
        if (this.filtersKeys.has(key)) {
          if (this.filterList.has(key)) {
            this.filterList.get(key).active = true;
          } else {
            this.filterList.get(key).active = false;
          }
        }
      }
      const activeFilterKeys: string[] = Array.from(this.filterList.values())
        .filter(value => value.active === true).map(filter => filter.name);
      this.store.dispatch(AddActiveMobileFilters({ keys: activeFilterKeys }));
    }, 0);
  }

  private getCurrentParams(): void {
    this.route.queryParams.pipe(
      takeUntil(this.componentDestroyer)
    ).subscribe((queryParams: Params) => {
      if (queryParams.id) {
        if (queryParams.p && queryParams.b) {
          this._search_pharmcy_params_count = queryParams.p;
          this._search_pharmcy_params = [{ id: queryParams.id, packageNum: queryParams.p, blisterNum: queryParams.b }];
          this.filterList = PharmcyPageService.getDefaultFilters(queryParams, this.filterList);
          this.isListSearch = false;
        } else if (queryParams.p) {
          this._search_pharmcy_params_count = queryParams.p;
          this._search_pharmcy_params = [{ id: queryParams.id, packageNum: queryParams.p, blisterNum: 0 }];
          this.filterList = PharmcyPageService.getDefaultFilters(queryParams, this.filterList);
          this.isListSearch = false;
        } else {
          this._search_pharmcy_params_count = queryParams.id.split(',').length;
          this._search_pharmcy_params = PharmcyPageService.getParamsForRequestList(queryParams);
          this.filterList = PharmcyPageService.getDefaultFilters(queryParams, this.filterList);
          this.isListSearch = true;
        }
        this.seoService.addBlockedForIndexing();
        if (!queryParams.map) {
          this.getPharmies(this._search_pharmcy_params, false, this.filterList);
        }
      } else {
        // если в параметрах нет id, то значит это один продукт с дэфолтным значением пачек 1 и блистеров 0, далее билдим id из урлы и делаем запрос
        // так же скипаем этот запрос если в параметрах есть ключ map, ключ этот появляется в мобильной версии, когда переходим на табку с мапой
        this._search_pharmcy_params = [{ id: +this.navigationHelper.getProductIdFromLocationPathname(), packageNum: 1, blisterNum: 0 }];
        this.filterList = PharmcyPageService.getDefaultFilters(queryParams, this.filterList);
        this.isListSearch = false;
        this.seoService.removeBlockedForIndexing();
        if (!queryParams.map) {
          this.getPharmies(this._search_pharmcy_params, false, this.filterList);
        }
      }
    });

    this.navigationHelper.navigateEmmiter.pipe(
      delay(325),
      takeUntil(this.componentDestroyer)
    ).subscribe(() => {
      // если находимся на странице аптек в десктопе с одним препаратом без квери параметров в урле и открываем попап с избранным
      // или просмотренным и жмем "выбрать аптеку", то эмитится сабджект в сервисе и тригерится эта подписка,
      // далее смотрим чтоб не было квери парамсов в урле и делаем запрос на новый препарат
      if (this.platformLocation.search === "") {
        this._search_pharmcy_params = [{ id: +this.navigationHelper.getProductIdFromLocationPathname(), packageNum: 1, blisterNum: 0 }];
        this.filterList = PharmcyPageService.getDefaultFilters({}, this.filterList);
        this.isListSearch = false;
        this.seoService.removeBlockedForIndexing();
        this.getPharmies(this._search_pharmcy_params, false, this.filterList);
      }
    });
  }

  private checkAddressState(): void {
    let selectedAddress: IFullAddress;
    if (this.location.address.length > 0) {
      selectedAddress = JSON.parse(this.location.address);
    }
    if (selectedAddress) {
      this.store.dispatch(SetAddressAction({ address: selectedAddress }));
    }
  }

  private checkGuardDataAndSetSeoStuff(
    guardData: { city: ICity, product: IProduct }
  ): void {
    if (guardData.product.image && guardData.product.name && guardData.city) {
      const cityName: string = this.local.getLang() === 'ua' ? guardData.city.hintUa : guardData.city.hintRu;
      const { title, description } = this.pharmaciesSeoHelper.buildTitleAndDescription(
        guardData.product.name,
        guardData.product.description,
        cityName
      );
      const webpImageUrl: string = 'https:' + environment.staticIMG + '500-375/' + guardData.product.image + '.webp';
      const imageAlt: string = this.local.getLang() === 'ua' ? `Ціни на ${guardData.product.name}` : `Цены на ${guardData.product.name}`;
      this.seoService.addOgImage(webpImageUrl);
      this.seoService.addTwitterCard({ title, description, image: webpImageUrl, alt: imageAlt });
    }
    if (guardData.product.crumbs) {
      this.crumbs = guardData.product.crumbs;
      this.setSeoCrumbsScript();
    }
  }

  private setInitialCenterMap(
    guardData: { city: ICity, product: IProduct },
    selectedAddress: IFullAddress | null,
    selectedCityName: string
  ): void {
    // Если выбрана улица, то центровать карту по выбранной улице с увеличение зума.
    // Но для прямого захода на страницу с городом, который не соответствует выбронному городу,
    // центруем карту по городу из урлы без увеличения зума.
    if (selectedAddress) {
      if (
        guardData.city.hintRu !== selectedCityName &&
        guardData.city.hintUa !== selectedCityName
      ) {
        this.store.dispatch(SetCenterMapAction({ center: [guardData.city.latitude, guardData.city.longitude] }));
      } else {
        this.store.dispatch(SetCenterMapAction({ center: [selectedAddress.latitude, selectedAddress.longitude] }));
        this.store.dispatch(SetZoomMapAction({ zoom: 15 }));
      }
    } else {
      this.store.dispatch(SetCenterMapAction({ center: [guardData.city.latitude, guardData.city.longitude] }));
      // Таймаут потому что диспатч срабатывает быстрее, чем загружается карта, на которой висит лисенер на смену города
      setTimeout(() => {
        this.store.dispatch(ChangePharmaciesCityAction({ newCity: guardData.city }));
      }, 0);
    }
  }

  private setSeoCrumbsScript(): void {
    this.jsonLDService.add(
      JsonLDServiceService.Breadcrambs(
        JsonLDServiceService.mutationCrambs(
          this.jsonLDService.getSeoBreadCrumbsWithUrlField(this.crumbs)
        )
      ),
      'structured-data-crumbs'
    );
  }

  private setInitCityName(): void {
    if (isPlatformServer(this.platformId)) {
      this.selectedUserCityName = this.cook.getItem('cityName')
        ? decodeURIComponent(this.cook.getItem('cityName'))
        : this.local.getLang() === 'ua' ? 'Київ' : 'Киев';
    } else {
      this.selectedUserCityName = this.location.cityName ? this.location.cityName
        : this.cook.getItem('cityName') ? decodeURIComponent(this.cook.getItem('cityName'))
          : this.local.getLang() === 'ua' ? 'Київ' : 'Киев';
    }
  }

  private cityChangeListener(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.actions.pipe(
        ofType(SetCurrentCityAction),
        takeUntil(this.componentDestroyer)
      ).subscribe(() => {
        this.selectedUserCityName = this.location.cityName ? this.location.cityName
          : this.cook.getItem('cityName') ? decodeURIComponent(this.cook.getItem('cityName'))
            : this.local.getLang() === 'ua' ? 'Київ' : 'Киев';
      });
    }
  }

  private setCurrentCityForH1(city: ICity): void {
    if (this.local.getLang() === 'ua') {
      this.cityForH1 = city.caseUa;
    } else {
      this.cityForH1 = city.caseRu;
    }
  }

  private checkGeoLocationStateFromGuardData(guardData: {
    permissionStatus: PermissionStatus | null,
    isGeolocationDisabled: boolean,
    city: ICity
  }): void {
    const townIds = [Number(this.location.cityId)];
    if (guardData.city) {
      townIds.push(guardData.city.id);
    }

    let userTown: {
      townId?: number,
      latitude?: number,
      longitude?: number
    } = JSON.parse(this.location.userTown || '{}');

    if (userTown.townId) {
      townIds.push(userTown.townId);
    }

    const isTownIdsEqual = townIds.every((id) => id === townIds[0]);

    if (isTownIdsEqual || this.location.address) {
      this.shouldAutoSetDistanceFilter = true;
      if (this.filterList) {
        this.filterList.get('ds').active = true;
      }
    } else {
      this.shouldAutoSetDistanceFilter = false;
      if (this.filterList) {
        this.filterList.get('ds').active = false;
      }
    }

    if (guardData.isGeolocationDisabled) {
      this.store.dispatch(SetIsGeoLocationDisabled({ value: true }));
    }
  }

  private setMobileFiltersPopupListener(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.actions.pipe(
        ofType(SetFiltersFromMobilePharmaciesPopup),
        takeUntil(this.componentDestroyer)
      ).subscribe(({ state }) => {
        this.filterList = state;

        if (state.get('ds').active === false) {
          this.isDistanceFilterRemoved = true;
        }

        combineLatest([this.route.params, this.route.queryParams]).pipe(
          take(1)
        ).subscribe(([params, queryParams]) => {
          if (this.isListSearch) {
            const listParams: Params = {
              id: queryParams.id,
            }
            const filters: FilterListPharmcies[] = Array.from(state.values());
            filters.forEach((filter) => {
              if (filter.active) {
                listParams[filter.name] = filter.active;
              }
            });
            this.router.navigate(this.local.getReturnParamsLang(['pharmacies']), { queryParams: listParams });
          } else {
            let singlePreparatParams: Params = {};
            if (queryParams['id']) {
              singlePreparatParams['id'] = queryParams['id'];
            }
            if (queryParams['p']) {
              singlePreparatParams['p'] = queryParams['p'];
            }
            if (queryParams['b']) {
              singlePreparatParams['b'] = queryParams['b'];
            }
            const filters: FilterListPharmcies[] = Array.from(state.values());
            filters.forEach((filter) => {
              if (filter.active) { singlePreparatParams[filter.name] = filter.active; }
            });
            if (Object.keys(singlePreparatParams).length > 0) {
              this.router.navigate(
                this.local.getReturnParamsLang(['pharmacies', params.url, this.compareCitiesAndReturnRequired()]),
                { queryParams: singlePreparatParams }
              );
            }
          }
        });

        this.lazy.clearContainerPopupGlobalContainer(document.getElementById('popupGlobalApp').firstChild);
      });
    }
  }

  private resetFiltersFromMobilePopup(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.actions.pipe(
        ofType(ResetFiltersFromMobilePharmaciesPopup),
        takeUntil(this.componentDestroyer)
      ).subscribe(() => {
        this.isDistanceFilterRemoved = true;

        const filters: FilterListPharmcies[] = Array.from(this.filterList.values()).map((filter) => ({ ...filter, active: false }));
        const newFiltersMap: Map<string, FilterListPharmcies> = new Map();
        filters.forEach((element) => newFiltersMap.set(element.name, element));
        this.filterList = newFiltersMap;

        combineLatest([this.route.params, this.route.queryParams]).pipe(
          take(1)
        ).subscribe(([params, queryParams]) => {
          if (this.isListSearch) {
            if (Object.keys(queryParams).length > 1) {
              this.router.navigate(this.local.getReturnParamsLang(['pharmacies']), { queryParams: { id: queryParams.id } });
            } else {
              this.getPharmies(this._search_pharmcy_params, false, this.filterList);
            }
          } else {
            if (Object.keys(queryParams).length > 0) {
              this.router.navigate(this.local.getReturnParamsLang(['pharmacies', params.url, this.compareCitiesAndReturnRequired()]));
            } else {
              this.getPharmies(this._search_pharmcy_params, false, this.filterList);
            }
          }
        });

        this.lazy.clearContainerPopupGlobalContainer(document.getElementById('popupGlobalApp').firstChild);
      });
    }
  }

  ngOnDestroy(): void {
    if (this.listenerFn) {
      this.listenerFn();
    }

    if (this.scr.isMobile()) {
      this.setHeightForMap('auto');
    }

    this.jsonLDService.remove();

    this.seoService.resetAll();
    this.seoService.removeBlockedForIndexing();

    this.componentDestroyer.next(null);
    this.componentDestroyer.complete();

    if (this.map) { this.lazy.clearContainer(this.map); }

    if (isPlatformBrowser(this.platformId) && this.location.location && this.needToResetMap) {
      const coords: string[] = this.location.location.split(',');
      this.store.dispatch(SetCenterMapAction({ center: [+coords[0], +coords[1]] }));
    }

    this.store.dispatch(SwitchMobilePageMapAction({ active: false }));
    this.store.dispatch(AddQuantityAction({ quantity: null }));
    this.store.dispatch(isGetOtherCityPharmaciesAction({ other: false }));
    this.store.dispatch(IsTargetFromProductCardGetOtherCityPharmaciesAction({ other: false }));
    this.store.dispatch(ResetOtherPageCountLoadPharmaciesAction());
  }
}


